// extracted by mini-css-extract-plugin
module.exports = {"MultipleMessages":"styles_MultipleMessages__3rPUr"};